module.exports = __webpack_public_path__ + "static/media/favorite-icon-pet-2.6a2205f7.svg";